import React from 'react';
import { SCol, SRow } from '@avalara/skylab-sdk/react';
import Subtext from './order-item-subtext';
const OrderItem = ({ name, price, strikethrough, subtext, nameStyle, priceStyle }) => (React.createElement(React.Fragment, null,
    React.createElement(SRow, { className: 'pad-top-xs' },
        React.createElement(SCol, { span: '8', style: nameStyle }, name),
        React.createElement(SCol, { "data-ref": "buy.order-summary.price", span: '4', style: priceStyle, className: `text-right${strikethrough ? ' text-strikethrough' : ''}` },
            React.createElement("span", null, price))),
    subtext && React.createElement(SRow, null,
        React.createElement(SCol, null,
            React.createElement(Subtext, { text: subtext })))));
export default OrderItem;
